interface IndexItem {
  icon: string;
  title: string;
  desc: string;
  count: string;
}

const indexItems: IndexItem[] = [
  { icon: 'ri-star-smile-line', title: '明星恋情追踪', desc: '最新明星恋情曝光、分手实锤与感情动态', count: '128篇' },
  { icon: 'ri-movie-2-line', title: '影视圈大瓜', desc: '剧组内幕、片酬风波与行业潜规则揭秘', count: '96篇' },
  { icon: 'ri-live-line', title: '综艺翻车现场', desc: '综艺节目争议片段、选手黑料与制作内幕', count: '87篇' },
  { icon: 'ri-music-2-line', title: '音乐圈风波', desc: '歌手争议、抄袭风波与演唱会幕后故事', count: '74篇' },
  { icon: 'ri-user-smile-line', title: '网红翻车实录', desc: '网红塌房、虚假人设与直播带货争议', count: '112篇' },
  { icon: 'ri-government-line', title: '法制瓜专区', desc: '明星涉法事件、偷税漏税与违法犯罪追踪', count: '53篇' },
  { icon: 'ri-heart-pulse-line', title: 'CP真假鉴定', desc: '热门CP真实关系分析、互动细节挖掘', count: '91篇' },
  { icon: 'ri-global-line', title: '海外吃瓜速递', desc: '国际明星八卦、韩娱日娱最新瓜讯', count: '68篇' },
];

const SectionIndex = () => (
  <section id="index" className="py-16 md:py-20 bg-background-50">
    <div className="max-w-[1280px] mx-auto px-4 md:px-6">
      <div className="text-center mb-10">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">吃瓜专题</h2>
        <p className="mt-2 text-sm text-foreground-500">按题材分类，精准追瓜不迷路</p>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
        {indexItems.map((item) => (
          <a
            key={item.title}
            href="#index"
            className="group flex flex-col items-center p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/50 transition-all cursor-pointer"
          >
            <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
              <i className={`${item.icon} text-xl`}></i>
            </span>
            <h3 className="mt-3 text-sm font-semibold text-foreground-900 whitespace-nowrap">{item.title}</h3>
            <p className="mt-1 text-xs text-foreground-500 text-center line-clamp-2">{item.desc}</p>
            <span className="mt-2 text-xs text-primary-500 font-medium">{item.count}</span>
          </a>
        ))}
      </div>
    </div>
  </section>
);

export default SectionIndex;